import { useState, useEffect } from 'react';
import { ArrowLeft, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="privacy-policy-page">
      <header className="sticky top-0 z-50 glass border-b border-[#2D231E]/10">
        <div className="container-max flex items-center h-16">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#5C4D43] hover:text-[#C44536] transition-colors" data-testid="back-from-privacy">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-sans text-sm font-medium">Volver</span>
          </button>
        </div>
      </header>

      <div className="container-max py-12 max-w-4xl">
        <div className="flex items-center gap-3 mb-8">
          <Shield className="w-8 h-8 text-[#C44536]" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2D231E]">Politica de Privacidad</h1>
        </div>

        <div className="prose prose-lg font-sans text-[#2D231E] space-y-6">
          <p className="text-[#5C4D43] text-sm">Ultima actualizacion: Abril 2026</p>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">1. Responsable del Tratamiento</h2>
            <p className="text-[#5C4D43]">
              <strong>Talwinder Singh Kaur</strong> (empresaria autonoma)<br />
              Nombre comercial: Taj Mahal San Fernando<br />
              NIF: 78317925G<br />
              Calle Real 109, San Fernando, Cadiz 11100, España<br />
              Email: Tajmahalsafernando@gmail.com<br />
              Telefono: +34 602 704 745
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">2. Datos que Recopilamos</h2>
            <p className="text-[#5C4D43]">Al realizar un pedido, recopilamos:</p>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-1">
              <li>Nombre completo</li>
              <li>Numero de telefono</li>
              <li>Direccion de entrega (solo para pedidos a domicilio)</li>
              <li>Detalles del pedido (articulos, cantidades, preferencias)</li>
            </ul>
            <p className="text-[#5C4D43] mt-3">
              <strong>No almacenamos datos bancarios ni de tarjetas de credito.</strong> Los pagos son procesados de forma segura por nuestro proveedor de pagos (Stripe/Redsys), que cumple con la normativa PCI DSS.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">3. Finalidad del Tratamiento</h2>
            <p className="text-[#5C4D43]">Utilizamos sus datos personales para:</p>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-1">
              <li>Procesar y gestionar sus pedidos</li>
              <li>Contactarle en relacion con su pedido</li>
              <li>Realizar la entrega a domicilio</li>
              <li>Cumplir con obligaciones legales y fiscales</li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">4. Base Legal</h2>
            <p className="text-[#5C4D43]">
              El tratamiento de sus datos se basa en la ejecucion de un contrato (su pedido) conforme al articulo 6.1.b del Reglamento General de Proteccion de Datos (RGPD) y la Ley Organica 3/2018, de 5 de diciembre, de Proteccion de Datos Personales y garantia de los derechos digitales (LOPDGDD).
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">5. Conservacion de Datos</h2>
            <p className="text-[#5C4D43]">
              Sus datos personales se conservaran durante el tiempo necesario para cumplir con la finalidad para la que fueron recogidos y para cumplir con las obligaciones legales aplicables. Los datos de pedidos se conservan durante el periodo legalmente establecido para obligaciones fiscales.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">6. Derechos del Usuario</h2>
            <p className="text-[#5C4D43]">Conforme al RGPD y la LOPDGDD, usted tiene derecho a:</p>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-1">
              <li><strong>Acceso:</strong> Conocer que datos personales tratamos sobre usted</li>
              <li><strong>Rectificacion:</strong> Corregir datos inexactos o incompletos</li>
              <li><strong>Supresion:</strong> Solicitar la eliminacion de sus datos</li>
              <li><strong>Oposicion:</strong> Oponerse al tratamiento de sus datos</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en un formato estructurado</li>
              <li><strong>Limitacion:</strong> Solicitar la limitacion del tratamiento</li>
            </ul>
            <p className="text-[#5C4D43] mt-3">
              Para ejercer estos derechos, contacte con nosotros en <strong>Tajmahalsafernando@gmail.com</strong>. Tambien puede presentar una reclamacion ante la Agencia Española de Proteccion de Datos (AEPD) en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">www.aepd.es</a>.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">7. Seguridad</h2>
            <p className="text-[#5C4D43]">
              Implementamos medidas tecnicas y organizativas adecuadas para proteger sus datos personales contra el acceso no autorizado, la alteracion, la divulgacion o la destruccion. Las comunicaciones se realizan mediante conexiones cifradas (HTTPS/SSL).
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">8. Terceros</h2>
            <p className="text-[#5C4D43]">
              Compartimos datos unicamente con los proveedores necesarios para la prestacion del servicio:
            </p>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-1">
              <li><strong>Proveedores de pago</strong> (Stripe/Redsys) - para procesar pagos de forma segura</li>
              <li><strong>WhatsApp/Meta</strong> - si elige realizar su pedido via WhatsApp</li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">9. Cookies</h2>
            <p className="text-[#5C4D43]">
              Este sitio web utiliza cookies tecnicas necesarias para el funcionamiento del carrito de compra y la sesion de usuario. No utilizamos cookies de seguimiento ni publicitarias. Consulte nuestra Politica de Cookies para mas informacion.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
